import * as React from 'react';
import { Field } from 'react-final-form';
import AutoSuggestSingle from '../../auto-suggest/AutoSuggestSingle';
import AutoSuggestInputForm from '../../auto-suggest/AutoSuggestFieldInput';
import { AutoSuggestFieldWrapperProps } from '.';
import { FormGroup } from 'reactstrap';
import {
	type AutoSuggestItem,
	type AutoSuggestMenuItemRenderProps,
	AutoSuggestRenderMenuProps,
} from 'components/shared/auto-suggest/Types';
import AutoSuggestMenu from 'components/shared/auto-suggest/AutoSuggestMenu';
import isEqual from 'react-fast-compare';
import AutoSuggestMenuItem from '~/components/shared/auto-suggest/AutoSuggestMenuItem';

/**
 * Wrapper field for AutoSuggestSingle to be used within forms
 *
 */
class AutoSuggestSingleField<T extends AutoSuggestItem = AutoSuggestItem> extends React.Component<
	AutoSuggestFieldWrapperProps<T>
> {
	public static defaultProps = {
		renderMenu: (props: AutoSuggestRenderMenuProps) => <AutoSuggestMenu {...props} />,
		renderMenuItem: (props: AutoSuggestMenuItemRenderProps) => <AutoSuggestMenuItem {...props} />,
		isRequired: false,
		disabled: false,
		indicateDirty: true,
		readOnly: false,
		clearable: true,
	};

	public render() {
		const {
			name,
			label,
			forceEmptyLabel,
			labelElementHidden,
			autoSuggestOptions,
			isRequired,
			disabled,
			indicateDirty,
			readOnly,
			prefix,
			suffix,
			isPowerUser,
			placeholder,
			renderMenu,
			renderSingleValue,
			renderMenuItem,
			clearable,
			inputTypeOverride,
			onChange,
			testId,
			setValueMapping,
		} = this.props;

		return (
			<Field name={name} isEqual={isEqual}>
				{({ input, meta }) => (
					<FormGroup className={indicateDirty && meta.dirty ? 'form-group--dirty' : ''}>
						<AutoSuggestSingle
							testId={testId}
							name={input.name}
							label={label}
							value={input.value}
							onChange={(value) => {
								if (setValueMapping) {
									input.onChange(setValueMapping(value));
								} else {
									input.onChange(value);
								}

								if (onChange) {
									onChange(value);
								}
							}}
							autoSuggestOptions={autoSuggestOptions}
							renderMenu={renderMenu}
							renderMenuItem={renderMenuItem}
							renderSingleValue={renderSingleValue}
							clearable={clearable}
							renderInput={() => (
								<AutoSuggestInputForm
									testId={testId}
									disabled={disabled}
									readOnly={readOnly}
									indicateDirty={indicateDirty}
									meta={meta}
									label={label}
									forceEmptyLabel={forceEmptyLabel}
									labelElementHidden={labelElementHidden}
									isRequired={isRequired}
									name={name}
									allowNewValues={autoSuggestOptions.allowNewValues}
									prefix={prefix}
									suffix={suffix}
									isPowerUser={isPowerUser}
									placeholder={placeholder}
									inputTypeOverride={inputTypeOverride}
								/>
							)}
						/>
					</FormGroup>
				)}
			</Field>
		);
	}
}

export default AutoSuggestSingleField;
